module.exports = __webpack_public_path__ + "img/us.19e568f4.svg";